import { ApolloError } from '@apollo/client';

export type GraphQLError = {
  message?: string;
  details?: Record<string, string>;
};
// helper function that transform error object into readable string
// usable for getting error message when making Prettyprint
export const getStringFromError = (error: ApolloError): string => {
  const graphQLError: GraphQLError = error?.graphQLErrors?.[0];
  const message = graphQLError?.message;
  const details = graphQLError?.details;
  if (details && details.lineNumber && details.columnNumber) {
    return `${details.content} at line ${details.lineNumber}, column:${details.columnNumber}`;
  }
  if (details?.content) {
    return details.content;
  }
  if (message) {
    return message;
  }
  return 'An unknown error occurred.';
};
